import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, Switch, Redirect} from "react-router-dom";
import Login from './pages/login'
import Admin from "./admin";
import App from "./App";
import Home from "./pages/home";
import NotFound from "./pages/notfound";
import UserList from "./pages/userList";//用户列表
import Channel from "./pages/channel";//渠道设置
import Group from "./pages/home/group";//
import GoodsList from "./pages/goodsList";//标准商品
import GoodsEditor from "./pages/goodsEditor";//新建、编辑商品
import GoodsClassify from "./pages/goodsClassify";//分类管理
import GoodsSku from "./pages/goodsSku";//规格管理
import GroupsList from "./pages/groupsList";//团购列表
import GroupsDetail from "./pages/groupsList/groupsDetail";//团购详情
import GroupsExamine from "./pages/groupsExamine";//待审核
import OrdersList from "./pages/ordersList";//订单列表
import OrderDetail from "./pages/ordersList/orderDetail/orderDetail";//订单详情
import OrdersReport from "./pages/ordersReport";//订单报表
import OrdersTiming from "./pages/ordersTiming";//定时任务
import OrdersDelivery from "./pages/ordersDelivery";//配送单
import DeliveryDetail from "./pages/ordersDelivery/deliveryDetail";//配送单详情
import AfterSales from "./pages/afterSales";//售后管理
import Finance from "./pages/finance";//资产概况
import Merchant from "./pages/merchant";//微信商户号 hook
import Register from "./pages/login/register";//注册商户
import ChannelList from "./pages/channel/channelList";//渠道列表
import ChannelMembers from "./pages/channel/channelMembers";
import {initToken, NEED_CREATE, resetToken, setToken, tokenStatus, USE_ABLE} from "./store/token";
import {state} from './store';
import EventDispatcher from "./events";
import {LoadCurrentMerchantInfoEvent} from "./events/LoadCurrentMerchantInfoEvent"
import {MERCHANT_STATE} from "./store/merchant";
import {connect, useDispatch} from "react-redux";
import {useLocation} from "react-router";
import qs from "./utils/qs";

function useQuery(search) {
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

global.router = null;
const basename = process.env.REACT_APP_BASE_NAME;
const Routes = (props) => {
    const dispatch = useDispatch();
    const query = useQuery(props.location.search);
    let token = query.get('token');
    const [tokenRefresh, setTokenRefresh] = useState(token);
    let ttl = query.get('ttl');
    let refreshTtl = query.get('refresh_ttl');
    let login = true;
    let status = tokenStatus(state);
    let id = setTimeout(() => {
        if (token) {
            dispatch(setToken({
                value: token,
                ttl: ttl,
                refreshTtl: refreshTtl ? refreshTtl : ttl
            }));
        } else {
            dispatch(initToken())
        }
        status = tokenStatus(state);
        if (props.merchant && status === USE_ABLE && props.merchant.merchantId === 0) {
            EventDispatcher.dispatch(new LoadCurrentMerchantInfoEvent());
        } else if (status === NEED_CREATE) {
            login = false;
        }
        clearTimeout(id);
    }, 300);
    return (<>
        <Switch token={tokenRefresh}>
            <Route path="/" exact render={() => {
                return (status === USE_ABLE ? <Admin>
                    <Route path='/' component={Home}/>
                </Admin> : <Route path='/' component={Login}/>);
            }}/>
            <Route path='/login' component={Login}/>
            <Route path="/register" exact component={Register}/>
            <Route path='/admin' render={() => <Admin>
                <Route path='/admin' component={Home}/>
            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>
            <Route path='/user' render={() => <Admin>
                <Route path='/user/userList' component={UserList}/>
                <Route path='/user/channel' component={Channel}/>
                <Route path='/user/channelList' component={ChannelList}/>
                <Route path='/user/group' component={Group}/>
                <Route path='/user/channelMembers' component={ChannelMembers}/>
            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>


            <Route path='/goods' render={() => <Admin>
                <Route path='/goods/goodsList' component={GoodsList}/>
                <Route path='/goods/goodsEditor' component={GoodsEditor}/>
                <Route path='/goods/goodsClassify' component={GoodsClassify}/>
                <Route path='/goods/goodsSku' component={GoodsSku}/>

            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>


            <Route path='/group' render={() => <Admin>
                <Route path='/group/groupsList' component={GroupsList}/>
                <Route path='/group/groupsExamine' component={GroupsExamine}/>
                <Route path='/group/groupsDetail' component={GroupsDetail}/>

            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>


            <Route path='/order' render={() => <Admin>
                <Route path='/order/ordersList' component={OrdersList}/>
                <Route path='/order/orderDetail' component={OrderDetail}/>
                <Route path='/order/ordersReport' component={OrdersReport}/>
                <Route path='/order/ordersTiming' component={OrdersTiming}/>
                <Route path='/order/ordersDelivery' component={OrdersDelivery}/>
                <Route path='/order/deliveryDetail' component={DeliveryDetail}/>
                <Route path='/order/afterSales' component={AfterSales}/>
            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>


            <Route path='/finance' render={() => <Admin>
                <Route path='/finance/list' component={Finance}/>
                <Route path='/finance/merchant' render={() => {
                    return <Merchant/>
                }}/>
            </Admin>}>
                {login ? '' : <Redirect to="/login"></Redirect>}
            </Route>
            <Route path='/404' component={NotFound}/>
            <Redirect to='/404'/>
        </Switch>
        <Route path='/order/orderDetail' element={
            <Admin>
                <OrderDetail/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>

        <Route path='/order/ordersReport' element={
            <Admin>
                <OrdersReport/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>

        <Route path='/order/ordersTiming' element={
            <Admin>
                <OrdersTiming/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>

        <Route path='/order/ordersDelivery' element={
            <Admin>
                <OrdersDelivery/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>

        <Route path='/order/deliveryDetail' element={
            <Admin>
                <DeliveryDetail/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>
        <Route path='/order/afterSales' element={
            <Admin>
                <AfterSales/>
            </Admin>
        }>
            {login ? '' : <Redirect to="/login"></Redirect>}
        </Route>
    </>);
};
const IRouter = (props) => {
    useEffect(() => {

    }, []);
    const routerRef = (ref) => {
        global.router = ref;
    };
    let merchant = props.merchant;
    return (
        <BrowserRouter basename={basename} ref={routerRef}>
            <Route path="" {...props} render={(props) => {
                return <Routes {...props} merchant={merchant}/>
            }}/>
        </BrowserRouter>
    );
}
const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE]
    }
}


export default connect(mapStateToProps)(IRouter);